import React from 'react';
import { toast } from 'react-toastify';
import { TextOnly } from './Text';

const CopyData = ({ info }: any) => {
  return (
    <button
      className="c-btn-icon"
      onClick={() => {
        if (!info) {
          toast.error(TextOnly('error'), {
            containerId: 'standard',
          });
          return;
        }

        let data = JSON.stringify(info, null, 2);
        navigator.clipboard.writeText(data as string).then(function () {
          toast.success(TextOnly('copied'), {
            containerId: 'standard',
          });
        });
      }}
    >
      <div className="c-btn__inner">
        <i className="fa fa-clipboard" />
      </div>
    </button>
  );
};

export default CopyData;
